import { useAccountPromotionalBannerOptOutFragment } from '@frameio/graphql-client/graphql/shared/types/generated/Account.schema';
import { useActiveAccountId } from '@frameio/shared/contexts';

// @TODO (FIND-3032): Currently I am fetching the AccountPromotionalBannerOptOut fragment as part
// of the GetAccountPermissions query so as not to incurr another round trip, but these single
// field queries should be consolidated into something like `GetAccountEssentialInfo` in the future.
export const useAccountPromotionalBannerOptOut = () => {
  const accountId = useActiveAccountId();
  const { data, complete } =
    useAccountPromotionalBannerOptOutFragment(accountId);

  // Default to true while query is still pending so we do not get a flash of the banner
  return complete ? data.promotionalBannerOptOut : true;
};
